<div class="loading">
  <div class="content">
    <h3 >{{ 'Draai je scherm in horizontaal voor een optimale beleving!' |translate}}</h3>

    <div class="img">
      <img src="./assets/images/rotate.png" alt="">
    </div>
  </div>
</div>
